import { pageId } from "@octopusdeploy/portal-routes";
export default () => ({
    projectGroup: {
        root: pageId({ area: "Project", id: "ProjectGroup.Edit", name: "Project Group" }),
    },
});
